import wixAnimations from 'wix-animations';

$w.onReady(function () {
    let loop = wixAnimations
        .timeline({ repeat: -1 })
        .add([$w("#vectorImage5"), $w("#vectorImage6")], { rotate: 360, duration: 7000, easing: "easeLinear" });
    loop.play();
});